
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/astra",
      function () {
        return require("private-next-pages/docs/auth/partnerships/astra.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/astra"])
      });
    }
  